import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { getUserInfo, judgeCourseProductsById, getServiceTeamId } from '../api/request';
import { getEnv, parseUrl } from '../utils';

const { evaluationReportId, saasId, chapterEvaluationContentId, evaluationContentId, isSubscribeList, projectId, teamType, sourcesType, sourcesId } = parseUrl();

const RedirectPage = () => {
    const editUrlAddNeed = (url) => {
        let resUrl = url;
        // 新类型拼接参数
        if (projectId) {
            resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}projectId=${projectId}`;
        }
        if (teamType) {
            resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}teamType=${teamType}`;
        }
        if (sourcesType) {
            resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}sourcesType=${sourcesType}`;
        }
        if (sourcesId) {
            resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}sourcesId=${sourcesId}`;
        }
        return resUrl;
    };

    const [loading, setLoading] = useState(true);
    // 解析url参数
    const getUrlParams = async () => {
        const domainUrl = `//${getEnv()}v.gaodun.com`;
        // 测评id 课程id 章id 节id
        if (+isSubscribeList === 1) {
            const { data } = await getServiceTeamId(evaluationReportId);
            if (data.status === 0 && data.result) {
                window.location.href = editUrlAddNeed(`${domainUrl}/tutor/subscribe/${data.result.serviceTeamId}?evaluationReportId=${evaluationReportId}&saas_id=${saasId}`);
                return;
            }
        }
        // 业务逻辑：根据id判断课程对应的产品数量，跳转对应的页面
        try {
            const userInfo = await getUserInfo();
            const { status, result } = userInfo.data && await judgeCourseProductsById({
                studentId: userInfo.data.UserData[0].StudentId,
                saasCourseId: saasId
            });
            const isTrue = result && result.isHaveDefaultTeam;
            if (status === 0) {
                // glive2给的参数是1就去列表
                // isHaveDefaultTeam:  true 预约页面, false: 选择团队
                isTrue
                    ? window.location.href = editUrlAddNeed(`${domainUrl}/tutor/booking/${result.serviceTeamId}?service_name=${result.serviceTeamName}&evaluationReportId=${evaluationReportId}&saas_id=${saasId}&chapterId=${chapterEvaluationContentId}&sectionId=${evaluationContentId}`) :
                    window.location.href = editUrlAddNeed(`${domainUrl}/tutor/bookinglist?evaluationReportId=${evaluationReportId}&saas_id=${saasId}&chapterId=${chapterEvaluationContentId}&sectionId=${evaluationContentId}`);
            } else {
                window.location.href = editUrlAddNeed(`${domainUrl}/tutor/bookinglist?evaluationReportId=${evaluationReportId}&saas_id=${saasId}&chapterId=${chapterEvaluationContentId}&sectionId=${evaluationContentId}`);
            }
        } catch (e) {
            window.location.href = editUrlAddNeed(`${domainUrl}/tutor/bookinglist?evaluationReportId=${evaluationReportId}&saas_id=${saasId}&chapterId=${chapterEvaluationContentId}&sectionId=${evaluationContentId}`);
        }
        setLoading(false);
    };


    useEffect(() => {
        getUrlParams();
    }, []);

    return (
        <div style={{ textAlign: 'center', paddingTop: 300 }}>
            <Spin
                spinning={loading}
                tip="页面加载中..." />
        </div>
    );
};

export default RedirectPage;